import types from "./action-types";
import { defaultSdState } from "./state";

const sdTickets = (state = defaultSdState.sdTickets, action) => {
  switch (action.type) {
    case types.SET_SD_TICKETS:
      return action.data;
    case types.UPDATE_SD_TICKET:
      return state.map((t) => (t.id === action.data.id ? action.data : t));
    default:
      return state;
  }
};

const sdTicket = (state = defaultSdState.sdTicket, action) => {
  switch (action.type) {
    case types.SET_SD_TICKET:
      return action.data;
    case types.UPDATE_SD_TICKET:
      return state && state.id === action.data.id ? action.data : state;
    case types.ADD_SD_COMMENT:
      if (!state) return state;
      return { ...state, comments: [...(state.comments || []), action.data] };
    default:
      return state;
  }
};

const sdLoading = (state = defaultSdState.sdLoading, action) => {
  switch (action.type) {
    case types.SET_SD_LOADING:
      return action.data;
    default:
      return state;
  }
};

export default { sdTickets, sdTicket, sdLoading };
